import { render, staticRenderFns } from "./settingDictionary.vue?vue&type=template&id=1c59322c&scoped=true"
import script from "./settingDictionary.vue?vue&type=script&lang=js"
export * from "./settingDictionary.vue?vue&type=script&lang=js"
import style0 from "./settingDictionary.vue?vue&type=style&index=0&id=1c59322c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c59322c",
  null
  
)

export default component.exports